import { InfoCircledIcon } from '@radix-ui/react-icons';
import { Box } from '@radix-ui/themes';
import { CommonCallout } from 'components/common/callouts';
import { ErrorBoundary } from 'components/common/error-boundary';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useAuthStore } from 'stores/use-auth-store';

export const GameStatusBanner = () => {
  const isInGame = useAuthStore((s) => s.isInGame);

  if (!isInGame) {
    return null;
  }

  return (
    <ErrorBoundary identifier="GameStatusBanner">
      <Box title="Your team is currently participating in a home game. Certain areas and features of the application will be disabled until the game ends.">
        <CommonCallout
          size="1"
          flexAlign="center"
          flexJustify="center"
          icon={<InfoCircledIcon />}
          color={RADIX.COLOR.SUCCESS}
          text="Live Game In Progress"
        />
      </Box>
    </ErrorBoundary>
  );
};
